import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Players from '@/components/Players'
import League from '@/components/League'
import Team from '@/components/Team'
import Rules from '@/components/Rules'
import Privacy from '@/components/Privacy'
import ToS from '@/components/ToS'

import firebase from 'firebase'

Vue.use(Router)

let router = new Router({
    mode: 'history',

    routes: [
      {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
          guest: true
        }

      },
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          auth: true
        }

      },
      {
        path: '/players',
        name: 'Players',
        component: Players,
        meta: {
          auth: true
        }

      },
      {
        path: '/league',
        name: 'League',
        component: League,
        meta: {
          auth: true
        }

      },
      {
        path: '/team/:leagueKey/:teamKey',
        name: 'Team',
        component: Team,
        props: true, 
        meta: {
          auth: true
        }

      },
      {
        path: '/rules',
        name: 'Rules',
        component: Rules,
      },
      {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy,
      },
      {
        path: '/tos',
        name: 'ToS',
        component: ToS,
      },
    ]

  },

)


router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next()
      } else {
        next({
          path: "/login",
        })
      }
    })
  } else if (to.matched.some(record => record.meta.guest)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        next({
          path: "/",
        })
      } else {
        next()
      }
    })

  } else {
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js